// extracted by mini-css-extract-plugin
module.exports = {"list":"Item_list__Q9OZ8"};